/**
 * Hands a file survey-api wrote to the browser's download — an object URL on a link pressed once,
 * then let go. The name is the caller's to give: survey-api's `Content-Disposition` where
 * `apiDownload` read one, a name of the caller's own where it did not.
 *
 * **Answers whether the browser took it**: the file arrived, so a throw here (a blocked object URL,
 * a Blob the browser will not hold) is not an answer that never arrived, and a caller says it as
 * `SAVE_REFUSED` rather than as a refusal of the read.
 */
export function saveFile(file: Blob, name: string): boolean {
  let url: string;
  try {
    url = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = url;
    link.download = name;
    document.body.append(link);
    link.click();
    link.remove();
  } catch {
    return false;
  }
  // After the click has been handled: revoking at once can cancel the download in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), 0);
  return true;
}

/** What a caller says when `saveFile` answers false. */
export const SAVE_REFUSED = 'The file was read, but the browser could not save it.';
